import React, { useState, useEffect } from "react";
import moment from "jalali-moment";
import PersianPrice from "../Header/PersianPrice";
import toFarsiNumber from "util/toFarsiNumber";
import { useTranslation } from "react-i18next";

const InvoiceDetailsMain = ({ detailData, classes }) => {
  const { pk, is_closed, end_time, start_time, total } = detailData;
  const { t } = useTranslation();
  const [localStorageData, setLocalStorageData] = useState({});

  useEffect(() => {
    const keys = Object.keys(localStorage);
    let i = keys.length;
    let values = [];
    while (i--) {
      values = { ...values, [keys[i]]: localStorage.getItem(keys[i]) };
    }
    setLocalStorageData(values);
  }, []);

  return (
    <div className={`${classes.mainContainer} w-100 p-2 rounded border`}>
      <div
        className={`${classes.itemContainer} col col-xs-12 col-sm-12 col-md-2 col-lg-2 `}
      >
        <p className="p-2 font-weight-bold">{t("invoices.customer")}</p>
        <p className="p-2">
          {localStorageData.firstname + " " + localStorageData.lastname}
        </p>
      </div>
      <div
        className={`${classes.itemContainer} col col-xs-12 col-sm-12 col-md-2 col-lg-2 `}
      >
        <p className="p-2 font-weight-bold">{t("invoices.number")}</p>
        <p className="p-2">{toFarsiNumber(pk)}</p>
      </div>
      <div
        className={`${classes.itemContainer} col col-xs-12 col-sm-12 col-md-2 col-lg-2 `}
      >
        <p className="p-2 font-weight-bold">{t("invoices.start_date")}</p>
        <p className="p-2">
          {toFarsiNumber(
            moment(start_time, "YYYY/MM/DD")
              .locale("fa")
              .format("YYYY/MM/DD")
          )}
        </p>
      </div>
      <div
        className={`${classes.itemContainer} col col-xs-12 col-sm-12 col-md-2 col-lg-2 `}
      >
        <p className="p-2 font-weight-bold">{t("invoices.end_date")}</p>
        <p className="p-2">
          {toFarsiNumber(
            moment(end_time, "YYYY/MM/DD")
              .locale("fa")
              .format("YYYY/MM/DD")
          )}
        </p>
      </div>
      <div
        className={`${classes.itemContainer} col col-xs-12 col-sm-12 col-md-2 col-lg-2 `}
      >
        <p className="p-2 font-weight-bold">{t("invoices.status")}</p>
        <p className="p-2">
          {is_closed ? t("invoices.closed") : t("invoices.current")}
        </p>
      </div>
      <div
        className={`${classes.itemContainer} col col-xs-12 col-sm-12 col-md-2 col-lg-2 `}
      >
        <p className="p-2 font-weight-bold">{t("invoices.total_amount")}</p>
        <p className="p-2">
          <span
            style={{
              display: "flex",
              width: "fit-content",
              backgroundColor: "rgba(0, 150, 136,0.1)",
              borderRadius: " 0.6em",
              padding: "0.5em ",
              margin: "0 auto",
              color: "rgba(0, 186, 186, 1)",
            }}
          >
            <PersianPrice number={Math.floor(total)} />
            <span className={classes.rial}>{t("invoices.rial")}</span>
          </span>
        </p>
      </div>
    </div>
  );
};

export default InvoiceDetailsMain;
